export const SEARCH_MAX_DEPTH = 3;
